require('/src/com/yext/listingslaunchstorm/js/components/styles/entitydetails.module.scss.module.css');

export const container = "_container_91guq_1";
export const icon = "_icon_91guq_1";
export const details = "_details_91guq_1";
